<script>
const GET_MULTIPLE_BEST_PRICES = () => import('gql/getMultipleBestPrices.gql');

export default {
  data() {
    return {
      bestPrices: {},
      loadingPrices: false,
      pricesNotFound: false,
      throttle: 1000,
    };
  },
  computed: {
    productIds() {
      console.error('implement productIds');
      return [];
    },
    requiresPrices() {
      return this.productIds.filter((id) => this.bestPrices[id] === undefined);
    },
  },
  watch: {
    requiresPrices() {
      this.updatePriceRequests();
    },
    loadingPrices() {
      this.updatePriceRequests();
    },
  },
  methods: {
    async updatePriceRequests() {
      if (
        IS_SSR ||
        this.loadingPrices ||
        this.pricesNotFound ||
        !(this.$fischer.shop.isOnlineShop() || this.$fischer.shop.isClosedShop()) ||
        this.requiresPrices.length === 0
      ) {
        return;
      }
      try {
        this.loadingPrices = true;
        const unknownBestPrices = this.requiresPrices
          .slice(0, 20) // do not overload backend
          .map((productCode) => ({ productCode }));
        const { data } = await this.$apollo.query({
          query: (await GET_MULTIPLE_BEST_PRICES()).default,
          variables: {
            baseSiteId: this.$fischer.baseSiteId(),
            language: this.$fischer.siteLanguage(),
            userId: this.$fischer.user.id(),
            accessToken: this.$fischer.user.accessToken(),
            queries: unknownBestPrices,
          },
        });
        if (!data.getMultipleBestPrices) {
          console.error('Did not receive best prices');
          this.pricesNotFound = true;
          return;
        }
        data.getMultipleBestPrices.forEach((bestPrice) => {
          if (bestPrice) {
            this.bestPrices[bestPrice.productCode] = bestPrice;
          }
        });
        unknownBestPrices.forEach(({ productCode }) => {
          if (this.bestPrices[productCode] === undefined) {
            this.bestPrices[productCode] = null;
          }
        });
      } finally {
        await new Promise((resolve) => setTimeout(resolve, this.throttle)); // throttle and make sure requiresPrices is evalueated
        this.throttle = Math.min(3000, this.throttle + 200);
        this.loadingPrices = false;
      }
    },
  },
};
</script>
